var _defs, _path, _text, _text2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpicLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 140",
    fill: "none",
    role: "img",
    "aria-label": "Epic Games",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shieldGrad",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#121212"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 4 L108 24 L108 72 C108 104 86 124 60 136 C34 124 12 104 12 72 L12 24 Z",
    fill: "url(#shieldGrad)",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 58,
    textAnchor: "middle",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    letterSpacing: 1.5
  }, "EPIC")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 78,
    textAnchor: "middle",
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: 2.5
  }, "GAMES")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 92 L60 98 L66 92",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpicLogo);
export default __webpack_public_path__ + "static/media/epic-logo.1cd785b3291cf4a7e14414b15875de24.svg";
export { ForwardRef as ReactComponent };